//@flow

class NewRelic {
    static notifyError(error: Error) {
        window.newrelic?.noticeError?.(error);
    }

    static trackData({
        clientId,
        personnelId
    }: {
        clientId: string,
        personnelId: string
    }) {
        NewRelic.track('clientId', clientId);
        NewRelic.track('personnelId', personnelId);
    }

    static track(key: string, data: string) {
        window.newrelic?.setCustomAttribute?.(key, data);
    }
}

export default NewRelic;
